import React from 'react';
const ChatIcon = ({ size=20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16v11H6l-2 5V4z" />
  </svg>
);
export default ChatIcon;